export const getApiKey = (): string => {
  const API_KEY = process.env.REACT_APP_API_KEY
  const apiKey = API_KEY ? `?API_KEY=${API_KEY}` : ''

  return apiKey
}
